var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        {
          attrs: {
            "list-type": "picture-card",
            limit: 1,
            "file-list": _vm.fileList,
            action: _vm.uploadPath,
            headers: _vm.uploadHeader,
            "on-preview": _vm.handlePictureCardPreview,
            "on-success": _vm.handleAvatarSuccess,
            "before-upload": _vm.beforeAvatarUpload,
            "before-remove": _vm.beforeRemove,
            "on-remove": _vm.handleRemove
          }
        },
        [_c("i", { staticClass: "el-icon-plus" })]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.picDialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.picDialogVisible = $event
            }
          }
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }